import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import useAuth from '@/composables/useAuth';
import useSeats from '@/composables/useSeats';
import { TEMP_NEW_TEAM_PAGE } from '@/constants/feature_flags';
import { useBillingStore, useFeatureFlagStore } from '@/stores';

export default function useTeamInvites() {
  const { hasScope } = useAuth();
  const canEditUsers = computed(() => hasScope('write:members'));

  const {
    isFreeTier,
    hasSubscription,
    isSubscriptionCancelled,
    isOnFreeTrial,
  } = storeToRefs(useBillingStore());
  const { atSeatLimit, mustTalkToSales } = useSeats();

  const ffStore = useFeatureFlagStore();
  const hasNewTeamPage = computed(() =>
    ffStore.hasFeatureFlag(TEMP_NEW_TEAM_PAGE),
  );

  const router = useRouter();
  const invitesDisabledReason = computed(() => {
    if (!canEditUsers.value)
      return 'You do not have permission to send invites';
    if (atSeatLimit.value && isFreeTier.value && !hasNewTeamPage.value)
      return 'Upgrade to Connector to purchase more seats';
    if (atSeatLimit.value && !isSubscriptionCancelled.value)
      return 'Unblock your team by adding more seats to Crossbeam';
    if (atSeatLimit.value && isSubscriptionCancelled.value)
      return 'Your subscription is cancelled and you are at your seat limit';
    return null;
  });
  const inviteTooltipButtonText = computed(() => {
    if (!isFreeTier.value && hasSubscription.value && !isOnFreeTrial.value)
      return hasNewTeamPage.value ? 'Add seats' : 'Buy Seats';
    if (!isFreeTier.value && !hasSubscription.value && !isOnFreeTrial.value)
      return 'Talk to Sales';
    return 'Upgrade';
  });
  async function handleInvite() {
    await router.push({ name: 'invite_user' });
  }
  return {
    invitesDisabledReason,
    inviteTooltipButtonText,
    handleInvite,
    mustTalkToSales,
  };
}
